import { useState, useEffect } from "react";
import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Divider,
  Grid,
  TextField,
} from "@material-ui/core";
import { connect } from "react-redux";
import { editHost, updatePaymentDetails } from "src/actions/EditHost";

const AccountProfileDetails = ({
  host,
  editHost,
  updatePaymentDetails,
  ...rest
}) => {
  const [paymentDetails, setPaymentDetails] = useState({
    bankAccountNumber: "",
    bankAccountName: "",
    mobileMoneyNo: "",
    bankSwiftCode: "",
    bankName: "",
    bankBranch: "",
  });
  const [values, setValues] = useState({
    first_name: "",
    last_name: "",
    username: "",
    phone_number: "",
    address: "",
    country: "",
    about: "",
  });

  useEffect(() => {
    setValues({ host });
  }, [host]);

  const handleChange = (event, isProfile) => {
    if (isProfile) {
      setValues({
        ...values,
        [event.target.name]: event.target.value,
      });
    } else {
      setPaymentDetails({
        ...paymentDetails,
        [event.target.name]: event.target.value,
      });
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    editHost(values);
  };

  const handlePaymentDetailsSubmit = (e) => {
    e.preventDefault();
    updatePaymentDetails(paymentDetails);
  };

  return (
    <Card>
      <CardHeader subheader="The information can be edited" title="Profile" />
      <Divider />
      <CardContent>
        <form autoComplete="off" noValidate {...rest} onSubmit={handleSubmit}>
          <Grid container spacing={3}>
            <Grid item md={6} xs={12}>
              <TextField
                fullWidth
                helperText="Please specify the first name"
                label="First name"
                name="first_name"
                onChange={(e) => handleChange(e, true)}
                defaultValue={host?.User_ID.first_name}
                variant="outlined"
              />
            </Grid>
            <Grid item md={6} xs={12}>
              <TextField
                fullWidth
                label="Last name"
                name="last_name"
                onChange={(e) => handleChange(e, true)}
                defaultValue={host?.User_ID.last_name}
                variant="outlined"
              />
            </Grid>
            <Grid item md={6} xs={12}>
              <TextField
                fullWidth
                label="User name"
                name="username"
                onChange={(e) => handleChange(e, true)}
                defaultValue={host?.User_ID.username}
                variant="outlined"
              />
            </Grid>
            <Grid item md={6} xs={12}>
              <TextField
                fullWidth
                label="Email Address"
                name="email"
                onChange={(e) => handleChange(e, true)}
                defaultValue={host?.User_ID.email}
                variant="outlined"
              />
            </Grid>
            <Grid item md={6} xs={12}>
              <TextField
                fullWidth
                label="Phone Number"
                name="phone_number"
                onChange={(e) => handleChange(e, true)}
                type="text"
                defaultValue={host?.User_ID.phone_number}
                variant="outlined"
              />
            </Grid>
            <Grid item md={6} xs={12}>
              <TextField
                fullWidth
                label="Country"
                name="country"
                onChange={(e) => handleChange(e, true)}
                defaultValue={host?.User_ID.country}
                variant="outlined"
              />
            </Grid>
            <Grid item md={6} xs={12}>
              <TextField
                fullWidth
                label="Location"
                name="address"
                onChange={(e) => handleChange(e, true)}
                defaultValue={host?.User_ID.address}
                variant="outlined"
              />
            </Grid>
            <Grid item md={6} xs={12}>
              <TextField
                fullWidth
                label="Brief Bio"
                name="about"
                onChange={(e) => handleChange(e, true)}
                defaultValue={host?.User_ID.about}
                variant="outlined"
              />
            </Grid>
            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                p: 2,
              }}
            >
              <Button color="primary" variant="contained" type="submit">
                Save details
              </Button>
            </Box>
          </Grid>
        </form>
        <Divider style={{ marginTop: 30 }} />
        <CardHeader
          subheader="The information can be edited"
          title="Host Payment Details"
        />
        <form
          autoComplete="off"
          noValidate
          {...rest}
          onSubmit={handlePaymentDetailsSubmit}
        >
          <Grid container spacing={3}>
            <Grid item md={6} xs={12}>
              <TextField
                fullWidth
                label="Mobile Money Number"
                name="mobileMoneyNo"
                onChange={handleChange}
                defaultValue={host?.mobileMoneyNo}
                variant="outlined"
              />
            </Grid>
            <Grid item md={6} xs={12}>
              <TextField
                fullWidth
                label="Account Name"
                name="bankAccountName"
                onChange={handleChange}
                defaultValue={host?.bankAccountName}
                variant="outlined"
              />
            </Grid>
            <Grid item md={6} xs={12}>
              <TextField
                fullWidth
                label="Account Number"
                name="bankAccountNo"
                onChange={handleChange}
                defaultValue={host?.bankAccountNo}
                variant="outlined"
              />
            </Grid>
            <Grid item md={6} xs={12}>
              <TextField
                fullWidth
                label="Bank Name"
                name="bankName"
                onChange={handleChange}
                defaultValue={host?.bankName}
                variant="outlined"
              />
            </Grid>
            <Grid item md={6} xs={12}>
              <TextField
                fullWidth
                label="Bank Branch"
                name="bankBranch"
                onChange={handleChange}
                defaultValue={host?.bankBranch}
                variant="outlined"
              />
            </Grid>
            <Grid item md={6} xs={12}>
              <TextField
                fullWidth
                label="Bank Swift Code"
                name="bankSwiftCode"
                onChange={handleChange}
                defaultValue={host?.bankSwiftCode}
                variant="outlined"
              />
            </Grid>
            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                p: 2,
              }}
            >
              <Button color="primary" variant="contained" type="submit">
                Save details
              </Button>
            </Box>
          </Grid>
        </form>
      </CardContent>
    </Card>
  );
};

const mapStateToProps = (state) => ({
  host: state.edit_host?.host,
});

export default connect(mapStateToProps, { editHost, updatePaymentDetails })(
  AccountProfileDetails
);
